const eventsBaseUrl = '/api/v1/events';

export const eventsApi = `${eventsBaseUrl}/event/`;
